const AppleRepository = {
  getAccessToken: async (): Promise<string> => '',
  isSupported: (): boolean => false,
};

export {AppleRepository};
